var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChat4Line = function SvgChat4Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.887 16.5H19.7V5.7H5.3v12.047zm.623 1.8L3.5 21.45V4.8a.9.9 0 0 1 .9-.9h16.2a.9.9 0 0 1 .9.9v12.6a.9.9 0 0 1-.9.9z"
  })));
};
export default SvgChat4Line;